// extracted by mini-css-extract-plugin
export default {"cardWrapper":"styles_cardWrapper__O4Esw","paper":"styles_paper__Ulj7+","followButton":"styles_followButton__vn4ZC"};